import React from 'react';

const TokensHead: React.FC = React.memo(() => {
  return <div style={{ textAlign: 'left' }}>Tokens</div>;
});

export default TokensHead;
